





































































































import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import dataStore from "@/store";
import AuthenticatedUserProvider from "@/modules/account/authenticated-user-provider.service";
import AuthenticatedUser from "@/modules/account/authenticated-user.model";
import BulkProject from "@/modules/bulk-project/bulk-project.model";
import freshSalesDealUrl from "@/modules/bulk-project/fresh-sales-deal-url.function";

import FactoryStore from "@/modules/factory/store";

import { getFactoryInvoiceTypeName } from "../../factory-invoice-type.value";
import FactoryInvoiceStore from "../../store/index";
import FactoryInvoice from "../../factory-invoice.model";
import { FactoryInvoiceStatusValue } from "../../factory-invoice-status.value";

@Component({})
export default class FactoryInvoiceViewInfo extends Vue {
  @Prop({ required: true })
  public readonly invoiceId!: string;

  @Prop({ default: false })
  public readonly isBatchScope!: boolean;

  @Prop()
  public readonly batchTypeLabel?: string;

  @Prop()
  public readonly bulkProject?: BulkProject;

  @Prop()
  public readonly counterpartInvoice?: FactoryInvoice;

  @Inject("AuthenticatedUserProvider")
  private fUserProvider!: AuthenticatedUserProvider;

  private fFactoryInvoiceStore: FactoryInvoiceStore;
  private fFactoryStore: FactoryStore;

  get invoiceTypeName(): string {
    return this.invoice ? getFactoryInvoiceTypeName(this.invoice.type) : "";
  }

  get factoryLabel(): string {
    if (!this.invoice) {
      return "";
    }
    const factory = this.fFactoryStore.getFactoryById(this.invoice.factory);
    return factory?.name
      ? `Factory: ${factory.name}`
      : `Factory ID: ${this.invoice.factory}`;
  }

  get invoice(): FactoryInvoice | undefined {
    return this.fFactoryInvoiceStore.getFactoryInvoiceById(this.invoiceId);
  }

  get freshSalesOrderUrl(): string | undefined {
    if (!this.bulkProject) {
      return undefined;
    }

    return freshSalesDealUrl(this.bulkProject.freshSalesDealId);
  }

  get buyerNotesClass(): string {
    const user = this.fUserProvider.getUser();

    if (!user) {
      return "";
    }

    return user.role === AuthenticatedUser.ROLE_FACTORY ? "-highlighted" : "";
  }

  get vendorNotesClass(): string {
    const user = this.fUserProvider.getUser();

    if (!user) {
      return "";
    }

    return user.role === AuthenticatedUser.ROLE_FACTORY ? "" : "-highlighted";
  }

  get invoiceNumber(): string {
    if (!this.invoice) {
      return "";
    }

    return this.invoice.number;
  }

  get isPaid(): boolean {
    if (!this.invoice) {
      return false;
    }

    return this.invoice.status === FactoryInvoiceStatusValue.PAID;
  }

  get invoiceDate(): string {
    if (!this.invoice) {
      return "";
    }

    return this.invoice.createdAt
      ? this.invoice.createdAt.toLocaleDateString()
      : "";
  }

  get status(): string {
    if (!this.invoice) {
      return "";
    }

    const status = this.fFactoryInvoiceStore.getInvoiceStatusById(
      this.invoice.status
    );

    return status ? status.name : "";
  }

  get showVendorNotes(): boolean {
    if (!this.invoice || !this.invoice.vendorNotes) {
      return false;
    }

    return [
      FactoryInvoiceStatusValue.REVIEW,
      FactoryInvoiceStatusValue.UNPAID,
      FactoryInvoiceStatusValue.PAID,
    ].includes(this.invoice.status);
  }

  get showBuyerNotes(): boolean {
    if (!this.invoice || !this.invoice.buyerNotes) {
      return false;
    }

    return [
      FactoryInvoiceStatusValue.UNPAID,
      FactoryInvoiceStatusValue.PAID,
    ].includes(this.invoice.status);
  }

  constructor() {
    super();

    this.fFactoryStore = getModule(FactoryStore, dataStore);
    this.fFactoryInvoiceStore = getModule(FactoryInvoiceStore, dataStore);
  }
}
